import QualitativeIndicatorUnit from "./QualitativeIndicatorUnit";
import QuantitativeDimensionalIndicatorUnit from "./QuantitativeDimensionalIndicatorUnit";
import QuantitativeIndicatorUnit from "./QuantitativeIndicatorUnit";

const IndicatorUnitFactory = ({ indicator, ...params }) => {
    if (!indicator) return null;
    const indicatorType = indicator.indicatorDTOType;
    if (!indicatorType) return null;
    if (indicatorType === 'QUANTITATIVE') {
        return <QuantitativeIndicatorUnit indicator={indicator} {...params} />;
    }
    if (indicatorType === 'QUALITATIVE') {
        return <QualitativeIndicatorUnit indicator={indicator} {...params} />;
    }
    if (indicatorType === 'QUANTITATIVE_DIMENSIONAL') {
        return <QuantitativeDimensionalIndicatorUnit indicator={indicator} {...params} />;
    }
    return null;
}

export default IndicatorUnitFactory;